import React from 'react';

import * as t from './BlockProvider.types';

const BlockContext = React.createContext<t.Context>({
  blockId: null,
  pageHeaderRef: null,
});

export const BlockProvider = (props: t.Props) => {
  const value = React.useMemo(
    () => ({
      blockId: props.blockId,
      pageHeaderRef: props.pageHeaderRef,
    }),
    [props.blockId, props.pageHeaderRef],
  );

  return <BlockContext.Provider value={value}>{props.children}</BlockContext.Provider>;
};

export const useBlock = () => React.useContext(BlockContext) as t.NotEmptyContext;
